module.exports = __webpack_public_path__ + "static/media/peacock_dancing.79c13728.png";